import React from "react";
import { Route, Switch } from "react-router-dom";

import { NavBar, Footer } from "./components";
import { Home, Profile, ExternalApi, InviteUsers } from "./views";

import "./app.css";

const App = () => {
  return (
    <div id="app" className="d-flex flex-column h-100">
      <NavBar />
      <div className="container flex-grow-1">
        <div className="mt-5">
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/login" exact component={Home} />
            <Route path="/tokens" component={Profile} />
            <Route path="/external-api" component={ExternalApi} />
            <Route path="/invite-users" component={InviteUsers} />
          </Switch>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default App;
